var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegetarian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F2F2F2"
    },
    cx: 256.001,
    cy: 256.001,
    r: 256.001
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E6E6"
    },
    cx: 256.001,
    cy: 256.001,
    r: 165.322
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97E62"
    },
    d: "M207.499,89.985c7.246-4.684,16.371-5.777,24.339-2.468c2.585,1.073,5.064,2.543,7.427,4.528 c18.535,15.568,29.88,39.422,28.341,65.856c-2.355,40.452-35.376,73.031-75.855,74.883c-45.747,2.094-83.493-34.374-83.493-79.655 c0-24.776,11.298-46.91,29.021-61.536c0.384-0.318,0.772-0.621,1.164-0.911c8.987-6.68,21.348-6.542,30.598-0.232l2.141,1.461 c9.829,6.705,22.721,6.864,32.713,0.404L207.499,89.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E86B56"
    },
    d: "M141.411,153.13c0-24.776,11.298-46.91,29.021-61.536c0.044-0.037,0.09-0.069,0.133-0.104 l-1.524-1.04c-9.25-6.31-21.611-6.448-30.598,0.232c-0.39,0.291-0.778,0.594-1.164,0.911c-17.723,14.625-29.021,36.76-29.021,61.536 c0,45.281,37.745,81.749,83.493,79.655c4.358-0.2,8.622-0.776,12.779-1.659C168.47,223.477,141.411,191.466,141.411,153.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C67D"
    },
    d: "M360.033,72.759c6.103,2.129,11.339,5.086,14.72,10.934c8.901,15.407,10.756,34.735,3.061,52.613 c-11.775,27.36-42.765,41.587-71.197,32.713c-32.135-10.029-49.067-44.696-37.708-75.984c6.216-17.119,19.574-29.578,35.489-35.239 c6.219-2.21,12.003-1.103,17.906,1.166l0,0c8.406,11.678,22.994,17.179,37.018,13.959L360.033,72.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0B16E"
    },
    d: "M328.718,169.02c-32.135-10.029-49.067-44.696-37.708-75.984 c5.701-15.702,17.42-27.468,31.601-33.678c-0.099-0.134-0.209-0.259-0.307-0.395l0,0c-5.902-2.268-11.686-3.377-17.906-1.166 c-15.916,5.659-29.274,18.12-35.489,35.239c-11.359,31.288,5.573,65.954,37.708,75.984c9.428,2.942,19.134,3.331,28.331,1.558 C332.862,170.173,330.783,169.665,328.718,169.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABC971"
    },
    d: "M415.759,334.137c-16.165,11.536-34.518,17.99-57.127,56.688l-42.095-24.594 c22.609-38.698,19.211-57.859,21.331-77.601l16.366-34.754l52.799,27.013l17.19,31.925L415.759,334.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BADB82"
    },
    d: "M451.188,280.784c-1.561-0.911-3.168-1.669-4.802-2.291c3.781-18.729-4.446-38.596-21.865-48.773 c-17.419-10.177-38.765-7.588-53.225,4.903c-1.345-1.119-2.793-2.146-4.354-3.059c-15.296-8.937-34.938-3.781-43.875,11.514 c-8.937,15.296-3.782,34.938,11.514,43.875c8.071,4.715,17.351,5.503,25.632,2.953c3.851,7.742,9.916,14.49,17.941,19.177 c8.023,4.688,16.881,6.658,25.515,6.212c1.843,8.466,7.087,16.164,15.158,20.879c15.296,8.937,34.938,3.781,43.875-11.514 C471.638,309.364,466.484,289.721,451.188,280.784z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 251.777,
    cy: 335.076,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 267.052,
    cy: 276.592,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 216.708,
    cy: 372.981,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 372.33,
    cy: 197.345,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 328.802,
    cy: 195.245,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 249.702,
    cy: 370.525,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 232.609,
    cy: 298.24,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 206.492,
    cy: 331.392,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 180.044,
    cy: 344.285,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 165.223,
    cy: 311.132,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 196.534,
    cy: 294.556,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 206.492,
    cy: 261.403,
    r: 9.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ABC971"
    },
    cx: 163.382,
    cy: 277.98,
    r: 9.209
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.20d5aa189ad407e89f3725b8a75a2996.svg";
export { ForwardRef as ReactComponent };